import { Route, Routes } from 'react-router-dom';

import LoginView from './views/login/login.view';
import ProtectedRoute from './components/protected-route/protected-route.component';
import NotFoundView from './views/not-found/not-found.view';
import { screens } from './views';
import { generateUUID } from './utils/uuid.util';
import styles from './app.module.scss';
import AuthProvider from './providers/auth-provider';
import PasswordRecoveryView from './views/password-recovery/password-recovery.view';

const App = () => {
    return (
        <div id={styles.app}>
            <AuthProvider>
                <Routes>
                    <Route path="login" element={<LoginView />} />
                    <Route
                        path="password-recovery"
                        element={<PasswordRecoveryView />}
                    />
                    {/* Authenticated routes*/}
                    <Route element={<ProtectedRoute />}>
                        {screens.map((screen) => (
                            <Route
                                key={generateUUID()}
                                path={screen.path}
                                element={screen.element}
                            />
                        ))}
                    </Route>
                    <Route path={'*'} element={<NotFoundView />} />
                </Routes>
            </AuthProvider>
        </div>
    );
};

export default App;
